import axios from 'axios'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useAnalyzerStore } from './useAnalyzer'
import useAuth from './useAuth'

export const useGetPatientData = () => {
    const { cid } = useParams()
    const { selectedSystem } = useAuth()
    const { start_date, end_date } = useAnalyzerStore()
    const [patient, setPatient] = useState(null)

    useEffect(() => {
        const init = async () => {
            const response = await axios.get(
                `/api/analyzer/${selectedSystem?.system_id}/patient/${cid}`,
                {
                    params: { start_date, end_date },
                }
            )
            setPatient(response?.data || null)
        }
        init()
    }, [cid, start_date, end_date, selectedSystem])

    return { patient }
}
export const useGetPatientByIdLastOne = () => {
    const { cid } = useParams()
    const { selectedSystem } = useAuth()
    const { start_date, end_date } = useAnalyzerStore()
    const [patient, setPatient] = useState(null)

    useEffect(() => {
        const init = async () => {
            const response = await axios.get(
                `/api/analyzer/${selectedSystem?.system_id}/patient/${cid}/last`,
                {
                    params: { start_date, end_date },
                }
            )
            setPatient(response?.data || null)
        }
        init()
    }, [cid, start_date, end_date, selectedSystem])

    return { data: patient }
}

export const useGetPatientByIdCountByDate = () => {
    const { cid } = useParams()
    const { selectedSystem } = useAuth()
    const { start_date, end_date } = useAnalyzerStore()
    const [patient, setPatient] = useState(null)

    useEffect(() => {
        const init = async () => {
            const response = await axios.get(
                `/api/analyzer/${selectedSystem?.system_id}/patient/${cid}/count_by_date`,
                {
                    params: { start_date, end_date },
                }
            )
            setPatient(response?.data || null)
        }
        init()
    }, [cid, start_date, end_date, selectedSystem])

    return { data: patient }
}

export const useGetPatientByIdCid = () => {
    const { cid } = useParams()
    const { selectedSystem } = useAuth()
    const { start_date, end_date } = useAnalyzerStore()
    const [patient, setPatient] = useState(null)

    useEffect(() => {
        const init = async () => {
            const response = await axios.get(
                `/api/analyzer/${selectedSystem?.system_id}/patient/${cid}/data_table_date`,
                {
                    params: { start_date, end_date },
                }
            )
            setPatient(response?.data || null)
        }
        init()
    }, [cid, start_date, end_date, selectedSystem])

    return { data: patient }
}
